import supportedLanguageIds, { SupportedLanguage } from 'lib/lexemes/supported-languages';

// See mapping:
// https://github.bumble.dev/server/bumble/blob/master/_packages/Partner/Partner.php::getTwitterAccountByLanguage
const mapTwitterAccountByLanguage: { [key in SupportedLanguage]?: string } = {
    de: 'Badoo_de',
    en: 'Badoo',
    es: 'Badoo_es',
    fr: 'Badoo_fr',
};

const mapHrefLang: { [key in SupportedLanguage]?: string } = {
    en: 'en-gb',
};

export const PARTNER_NAME = 'Badoo';

export const SHARE_IMAGE_URL =
    'https://badoo.com/dating-confidence-guide/assets/dating-confidence/badoo-dating-confidence-guide-social.png';

export function getTwitterAccountByLanguage(lang: SupportedLanguage): string {
    return (
        mapTwitterAccountByLanguage[lang] ||
        //@ts-ignore
        (mapTwitterAccountByLanguage[__DEFAULT_LANG__] as SupportedLanguage)
    );
}

export function getLanguageAlternates(baseUrl: string, route: string) {
    return supportedLanguageIds.map((lang) => {
        const hrefLang = mapHrefLang[lang] || lang;
        return {
            hrefLang,
            href: `${baseUrl}/${lang}/${getPathnameWithoutLangPrefix(route)}`,
        };
    });
}

export function getCanonical(baseUrl: string, route: string) {
    return `${baseUrl}/${getPathnameWithoutLangPrefix(route)}`;
}

function getPathnameWithoutLangPrefix(pathname: string) {
    const matches = /^(?:\/\[lang\])?(?:\/)?(.+)?$/.exec(pathname);
    return matches?.[1] || '';
}
